module.exports = __webpack_public_path__ + "static/media/1027852.17e556c6.png";